import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseRequisition, PurchaseRequisitionCreate, PurchaseRequisitionFilter } from '../data/purchaseRequisition';

export function createPurchaseRequisitionService(client: AxiosInstance) {
  return createCrudService<PurchaseRequisition, PurchaseRequisitionCreate, PurchaseRequisitionFilter>(
    client,
    '/purchase/PurchaseRequisition',
    'id',
  );
}

export type PurchaseRequisitionService = CrudService<PurchaseRequisition, PurchaseRequisitionCreate, PurchaseRequisitionFilter>;
